import { useTranslation } from 'react-i18next'

import { useSiteStore } from 'js/lib/stores/SiteStore'

import styles from './ReadOnlyModeBanner.module.css'

const ReadOnlyModeBanner = () => {
    const { t } = useTranslation()
    const readOnlyMode = useSiteStore((state) => state.site?.readOnlyMode)

    if (!readOnlyMode) {
        return null
    }

    return (
        <div className={styles.banner} role="status" aria-live="polite">
            <div className={styles.content}>{t('global.read-only-mode')}</div>
        </div>
    )
}

export default ReadOnlyModeBanner
